import React, {useEffect} from 'react';
import './App.css';
import './theme.css';
import {useTheme} from "./useTheme";
import {useState} from 'react';
import {BrowserRouter as Router, Routes, Route, HashRouter, useNavigate, useLocation} from "react-router-dom"
import MainPage from "./MainPage";
import Wishlist from "./Wishlist";
import LampaFeed from "./LampaFeed/LampaFeed";
import Lvchk from "./Lvchk/Lvchk";
import Resume from "./Resume/Resume";
import DiscordUnblock from "./DiscordUnblock";
import Statistics from "./Statistics";
import HpgRoll from "./HpgRoll";
import ProtectedRoute from './Protected/ProtectedRoute';
import KMMemories from "./KMMemories";
import MyMemories from "./MyMemories";
import WatchList from "./WatchList";
import WorkCalendar from "./WorkCalendar";
import LetterGlitch from "./LetterGlitch"; // добавить импорт
import GamesHub from "./Games/GamesHub";
import SpyGame from "./Games/Spy/SpyGame";
import UndercoverGame from "./Games/Undercover/UndercoverGame";
import CharadesGame from "./Games/Charades/CharadesGame";
import RiddlesGame from "./Games/Riddles/RiddlesGame";
import TabooGame from "./Games/Taboo/TabooGame";
import WhoAmIGame from "./Games/WhoAmI/WhoAmIGame";
import AssociationsGame from "./Games/Associations/AssociationsGame";
import TelephoneGame from "./Games/Telephone/TelephoneGame";
import StoryChainGame from "./Games/StoryChain/StoryChainGame";
import FibbageGame from "./Games/Fibbage/FibbageGame";
import CaptionDrawGame from "./Games/CaptionDraw/CaptionDrawGame";
import CaptionBattleGame from "./Games/CaptionBattle/CaptionBattleGame";
import Foxy from "./Foxy/Foxy";
import Transposer from "./Transposer/Transposer";

function App() {

    const navigate = useNavigate();
    const location = useLocation();
    const isGamesRoute = location.pathname.startsWith("/games");
    const isWatchlistHost = window.location.hostname === "watchlist.swathingsoap.com";
    // Only these pages have dark styles; the rest keep their own look
    const isThemedRoute = isWatchlistHost || ["/", "/resume", "/watchlist"].includes(location.pathname);
    const [theme, toggleTheme] = useTheme();

    useEffect(() => {
        const root = document.documentElement;
        if (isThemedRoute) {
            root.dataset.theme = theme;
        } else {
            delete root.dataset.theme;
        }
    }, [theme, isThemedRoute]);

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const generateGlitchColors = (count = 2) => {
        return Array.from({ length: count }, () => getRandomColor());
    };

    const [glitchColors] = useState<string[]>(generateGlitchColors(2));

    useEffect(() => {
        // Проверяем хеш на наличие #discord и перенаправляем на /discord
        if (window.location.hash === "#discord") {
            navigate("/discord");
        }

        // Добавляем обработчик изменения хеша
        const handleHashChange = () => {
            if (window.location.hash === "#discord") {
                // Перенаправляем на путь /discord, если хеш #discord
                navigate("/discord");
            }
        };

        window.addEventListener("hashchange", handleHashChange);

        // Убираем обработчик при размонтировании компонента
        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, [navigate]);

    const hostname = window.location.hostname;
    console.log(hostname);


  return (
      <div className="App">
          <div className={`StickyTop${isGamesRoute ? ' StickyTop--dark' : ''}`}>
              <a id="topLink" href="/"><img className="Logo-holder"
                                            src="https://i.imgur.com/G5wQfJW.png" alt="logo"/></a>
              {isThemedRoute && (
                  <button className="ThemeToggle" onClick={toggleTheme}
                          aria-label={theme === "dark" ? "Светлая тема" : "Тёмная тема"}
                          title={theme === "dark" ? "Светлая тема" : "Тёмная тема"}>
                      {theme === "dark" ? (
                          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                               strokeWidth="1.8" strokeLinecap="round">
                              <circle cx="12" cy="12" r="4.5"/>
                              <path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"/>
                          </svg>
                      ) : (
                          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                               strokeWidth="1.8" strokeLinejoin="round">
                              <path d="M20.5 14.2A8.5 8.5 0 1 1 9.8 3.5a6.8 6.8 0 0 0 10.7 10.7z"/>
                          </svg>
                      )}
                  </button>
              )}
              <hr className="Hr"></hr>
          </div>

          <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: -1,
              pointerEvents: 'none',
              overflow: 'hidden',
              opacity: 0.2, // Пониженная альфа
              filter: 'blur(1px)', // Эффект размытия
          }}>
             {/* <LetterGlitch
                  glitchColors={glitchColors}
                  glitchSpeed={50}
                  centerVignette={false}
                  outerVignette={false}
                  smooth={true}
              />*/}
          </div>

          {hostname === "watchlist.swathingsoap.com" ? (
              <Routes>
                  <Route path="/*" element={<WatchList/>}/>
              </Routes>
          ) : (
              <Routes>
                  <Route path="/wishlist" element={<Wishlist/>}/>
                  <Route path="/lampafeed" element={<LampaFeed/>}/>
                  <Route path="/lvchk" element={<Lvchk/>}/>
                  <Route path="/resume" element={<Resume/>}/>
                  <Route path="/discord" element={<DiscordUnblock/>}/>
                  <Route path="/foxy" element={<Foxy/>}/>
                  <Route path="/transpose" element={<Transposer/>}/>
                  <Route path="/youtube" element={<DiscordUnblock/>}/>
                  <Route path="/statistics" element={<Statistics/>}/>
                  <Route path="/hpg4roll" element={<HpgRoll/>}/>
                  <Route path="/watchlist" element={<WatchList/>}/>
                  <Route path="/workcalendar" element={<WorkCalendar/>}/>
                  <Route path="/games" element={<GamesHub/>}/>
                  <Route path="/games/spy" element={<SpyGame/>}/>
                  <Route path="/games/undercover" element={<UndercoverGame/>}/>
                  <Route path="/games/charades" element={<CharadesGame/>}/>
                  <Route path="/games/riddles" element={<RiddlesGame/>}/>
                  <Route path="/games/taboo" element={<TabooGame/>}/>
                  <Route path="/games/who-am-i" element={<WhoAmIGame/>}/>
                  <Route path="/games/associations" element={<AssociationsGame/>}/>
                  <Route path="/games/telephone" element={<TelephoneGame/>}/>
                  <Route path="/games/story-chain" element={<StoryChainGame/>}/>
                  <Route path="/games/fibbage" element={<FibbageGame/>}/>
                  <Route path="/games/caption-draw" element={<CaptionDrawGame/>}/>
                  <Route path="/games/caption-battle" element={<CaptionBattleGame/>}/>
                  <Route path="/" element={<MainPage/>}/>
                  <Route path="/kmMemories" element={<ProtectedRoute element={<KMMemories/>}/>}/>
                  <Route path="/myMemories" element={<ProtectedRoute element={<MyMemories/>}/>}/>
              </Routes>
          )}


      </div>
  );
}

export function LoadingImage() {
    return (
        <div>
            <img className="Rot-img" src="https://i.imgur.com/G5wQfJW.png"
                 alt="logo"/>
        </div>
    )
}




export default App;
